module.exports = __webpack_public_path__ + "static/media/screen8.8288c186.png";